import { render, staticRenderFns } from "./PointOriginal.vue?vue&type=template&id=0a780d5c&"
import script from "../../models/analysis/point-original.ts?vue&type=script&lang=ts&"
export * from "../../models/analysis/point-original.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports